import React from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from '@reach/router'
import { useStaticQuery, graphql } from 'gatsby'

export default({ description, lang, meta = [], title, image }) => {
  const { site: { siteMetadata: config } } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          defaultLang
          title
          titleTemplate
          description
          url
          twitter
          defaultImage
        }
      }
    }
  `)

  const { pathname } = useLocation()

  const seoDescription = description || config.description
  const seoLang = lang || config.defaultLang
  const seoUrl = `${config.url}${pathname}`
  const seoImage = `${config.url}${image || config.defaultImage}`

  return (
    <Helmet
      htmlAttributes={{ lang: seoLang }}
      title={title}
      titleTemplate={config.titleTemplate}
      meta={[
        { name: 'title', content: title },
        { name: 'description', content: seoDescription },
        { name: 'image', content: seoImage },

        { property: 'og:type', content: 'article' },
        { property: 'og:title', content: title },
        { property: 'og:description', content: seoDescription },
        { property: 'og:url', content: seoUrl },
        { property: 'og:image', content: seoImage },

        { property: 'twitter:card', content: 'summary' },
        { property: 'twitter:creator', content: config.twitter },
        { property: 'twitter:title', content: title },
        { property: 'twitter:description', content: seoDescription },
        { property: 'twitter:image', content: seoImage }
      ].concat(meta)}
    />
  )
}
